import React, { useEffect, useState } from "react";
import { columnsData } from './variables/columnsData';
import SearchTable from './components/SearchTable';
import Card from 'components/card';
import { API_BASE_URL } from 'config';

const ListObjects = () => {
  const resource = 'order/sales-order';
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/${resource}/`)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        const filteredData = data.results.map((result) => {
          const rowData = {};
          columnsData.forEach((column) => {
            const { accessor } = column;
            if (accessor === "name") {
              rowData[accessor] = [
                result[accessor],
                result["picture"],
              ];
            } if (accessor === "status") {
              rowData[accessor] = result[accessor]['status'];
            } else {
              rowData[accessor] = result[accessor];
            }
          });
          return rowData;
        });
        setTableData(filteredData);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, []);


  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error! {error.message}</div>;

  return (
    <Card extra={'w-full h-full bg-white mt-3'}>
      <SearchTable
        tableData={tableData}
        columnsData={columnsData}
        setTableData={setTableData}
      />
    </Card>
  );
};

export default ListObjects;
